// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customGrey":"#4b4b4b","customWhiteDk":"#fafafa","customWhite":"#ffffff","primaryGreen":"#028154","container":"f5QeR0sS-iqQyV2p3-lIA","checked":"_26x7KZPIUkYc67aE3GckpN"};


//////////////////
// WEBPACK FOOTER
// ./src/common/checkbox/Checkbox.css
// module id = 445
// module chunks = 0 1 2